import React from 'react';
import { applyStyles } from 'util/helpers';
import CustomMedia from 'util/custom-media-query';
import { css } from 'styled-components';
import i18n from 'i18n';
import FontStyles from 'constants/font-styles';

const PersonInfo = ({
  className,
  name,
  postcode,
  address,
  tel,
  email,
  nameKana
}) => (
  <div className={className}>
    <p>
      {name}
      {nameKana && `（${nameKana}）`}
    </p>
    {postcode && address && (
      <p>
        {i18n.t('common:postcode')} {postcode} {address}
      </p>
    )}
    <p>
      <span className={`content-label ${ email ? '' : 'no-width' }`}>{i18n.t('common:tel')}</span>
      <span> : </span>
      {tel}
    </p>
    {email && (
      <div className="email">
        <div className="email-label">
          <span className="content-label">
            {i18n.t('common:email')}
          </span>
          <span> : </span>
        </div>
        <div>
          <span>{email}</span>
        </div>
      </div>
    )}
  </div>
);

const commonStyle = css`
  .content-label {
    display: inline-block;
    font-weight: normal;

    &.no-width {
      width: auto;
    }
  }

  .email {
    display: flex

    div {
      &.email-label {
        min-width: 124px;
        margin-right : 5px;
      }
    }
  }
`
const pcStyle = CustomMedia.greaterThan('umedium')`
  p {
    margin: 0;
    margin-bottom: 2px;

    &:last-child {
      margin-bottom: 0px;
    }
  }

  .content-label {
    width: 115px;
    ${FontStyles.text8};
  }

  td {
    &.title {
      span {
        padding: 0 2px 0 2px;
      }
    }
  }
`
const spStyle = CustomMedia.lessThan('medium')`
  p {
    margin: 0;
    margin-bottom: 2px;

    &:last-child {
      margin-bottom: 0px;
    }
  }

  .content-label {
    width: 114px;
    ${FontStyles.text6};
  }

  td {
    &.title {
      span {
        padding: 0 2px 0 1px;
      }
    }
  }
`

export default applyStyles(PersonInfo)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/PersonInfo/index.js